import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M18.77 3.75H5.23c-2.32 0-4.13 1.72-4.13 3.96v8.57c0 2.24 1.81 3.96 4.13 3.96h13.53c2.32 0 4.13-1.72 4.13-3.96V7.71c0-2.3-1.87-3.96-4.13-3.96zm0 15H5.23c-1.55 0-2.63-1.11-2.63-2.46v-5.55l.96-1.16c.26-.31 1.1-.81 2.65-1.22 1.51-.4 3.53-.69 5.95-.69 4.87 0 7.73 1.17 8.69 2.01l.55.48v6.14c0 1.36-1.08 2.46-2.63 2.45",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M10.53 13.29H5.18c-.47-.01-.87.3-.88.71v.04c-.01.4.36.74.83.75h5.35c.47.01.87-.3.88-.71v-.04c.01-.4-.36-.74-.83-.75M4.94 11.9h4.14c.37.01.67-.3.68-.71v-.04c.01-.4-.28-.74-.64-.75H4.98c-.37-.01-.67.3-.68.71v.04c-.01.4.28.74.64.75m14.42 1.39h-5.35c-.47-.01-.87.3-.88.71v.04c-.01.4.36.74.83.75h5.35c.47.01.87-.3.88-.71v-.04c.01-.4-.36-.74-.83-.75m-8.83 2.69H5.18c-.47-.01-.87.3-.88.71v.04c-.01.4.36.74.83.75h5.35c.47.01.87-.3.88-.71v-.04c.01-.4-.36-.74-.83-.75m8.83 0h-5.35c-.47-.01-.87.3-.88.71v.04c-.01.4.36.74.83.75h5.35c.47.01.87-.3.88-.71v-.04c.01-.4-.36-.74-.83-.75",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }